module.exports = __webpack_public_path__ + "img/gold_bg.d7e27e84.png";